import React from "react";
import { useSchema } from "../../contexts/schema.context";
import { SchemaBlock } from "src/services/schema/types/schema.types";

/**
 * SchemaInjector organism component that renders Schema.org structured data
 * as a single JSON-LD script element using the @graph pattern.
 *
 * All schemas registered via the SchemaContext are combined into a single
 * <script type="application/ld+json"> with one @context and a @graph array.
 */
export const SchemaInjector: React.FC = () => {
  const { schemas } = useSchema();

  if (!schemas || schemas.length === 0) {
    return null;
  }

  // Strip any leftover @context from individual schemas (backwards compat)
  // and combine into a single @graph document
  const graphNodes = schemas.map((schema: SchemaBlock) => {
    const { "@context": _ctx, ...rest } = schema as Record<string, unknown>;
    return rest;
  });

  const graphDocument = {
    "@context": "https://schema.org/",
    "@graph": graphNodes,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(graphDocument) }}
    />
  );
};
